import { SelectedVehicleService } from 'src/app/services/selectedVehicle.service';
import { VehicleSearchTypeEnum } from './../../../models/enums/VehicleSearchTypeEnum';
import { element } from 'protractor';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { faArrowLeft, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';

import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgZone, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { EvaluationSummaryModel } from 'src/app/models/Evaluation/EvaluationSummaryModel';
import { Vehicle } from 'src/app/models/Vehicle';
import { AddEvaluationDataModel, EvaluationDomain, EvaluationDomainSkill, EvaluationDomainTemplates, EvaluationResultRanksModel } from 'src/app/models/Evaluation/AddEvaluationDataModel';
import { BehaviorSubject } from 'rxjs';
import { Customer } from 'src/app/models/Customer';
import { EvaluationDomainTemplateScopeEnum } from 'src/app/models/enums/Evaluation/EvaluationEnums';
import { Subscription } from 'rxjs';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';



@Component({
  selector: 'add-reviews',
  templateUrl: './add-reviews.component.html',
  styleUrls: ['./add-reviews.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddReviewsComponent implements OnInit {

  faTimesCircle = faTimesCircle;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faArrowLeft = faArrowLeft
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;

  bookedVehicle;
  currency;
  reviews;
  evaluationLogsMasters: EvaluationSummaryModel;
  vehicle: Vehicle;
  addEvaluationData: AddEvaluationDataModel;
  addEvaluationDataObservable: any;
  evaluationDomainTemplates:EvaluationDomainTemplates;
  evaluatorComment;
  customer: Customer;
  countRanks;
  errorReviewMsg = false;

  searchAvailableVehicleFilterType;
  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;
  searchType:VehicleSearchTypeEnum;
  subscriptions:Subscription[]=[];

  constructor(
    private searchService: SearchService,
    private cd: ChangeDetectorRef,
    private bookingService: BookingService,
    private dialogRef: MatDialogRef<AddReviewsComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private authService: AuthService,
    private router: Router,
    private formBuilder: FormBuilder,
    public translateService: TranslateService,
    private _ngZone: NgZone,
    private selectedVehicleService:SelectedVehicleService,
    private attachmentService: AttachmentService) {

    this.currency = searchService.getCurrency();


  }


  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  ngOnInit() {
    this.bookingService.vehicleReservationCaseResult.subscribe(res => {

      if (res != null) {

        let _evaluationLogsMasters = res.evaluationLogsMasters;
        if (_evaluationLogsMasters != null && _evaluationLogsMasters.evaluationLogsDetails != null && _evaluationLogsMasters.evaluationLogsDetails.length > 0) {

          this.evaluationLogsMasters = _evaluationLogsMasters;
        }
        else {


          this.addEvaluationDataObservable = new BehaviorSubject(res.addEvaluationData);
          this.addEvaluationDataObservable.subscribe(data => {

            this.addEvaluationData = data;
            this.evaluationDomainTemplates=data.evaluationDomainTemplates;
            this.countRanks=this.addEvaluationData.evaluationDomainTemplates.evaluationDomains[0].evaluationDomainSkills[0].evaluationDomainSkillAssessmentOptions?.length ?? 0;
          });
        }
      }

    })
    this.selectedVehicleService.vehicle.subscribe(res => {
      this.vehicle = res;
      this.searchType=this.bookingService.searchAvailableVehicleFilterType;

      let _cahcedVehicle = this.selectedVehicleService.getCachedVehicle();
      if (_cahcedVehicle != null) {
        this.searchType=_cahcedVehicle.searchAvailableVehicleFilterType;
      }

    });
    this.authService.loggedInCustomer.subscribe(res =>{
      this.customer=res;
    })


  }

  get vehicleSearchTypeEnum(){
    return VehicleSearchTypeEnum;
  }

  get attachmentScopesEnum(){
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum(){
    return AttachmentTypeEnum;
  }

  close(isAddedReview?:boolean): void {
    if(isAddedReview!=null)
    this.dialogRef.close({isAddedReview});
    else
    this.dialogRef.close();
  }

  sliderOnChange(review: EvaluationDomainSkill, evaluationDomainSkills: EvaluationDomain, value) {
    let globalEvaluationDomain = this.evaluationDomainTemplates.evaluationDomains.filter(a => a.evaluationDomainID == evaluationDomainSkills.evaluationDomainID)[0];
    let globalReview = globalEvaluationDomain.evaluationDomainSkills.filter(a => a.domainSkillID == review.domainSkillID)[0];
    globalReview.average = value;
    //review.average=value;
    this.updateDomainSkill(globalEvaluationDomain);
    this.calculateTotalEvaluation();

    this.cd.markForCheck();
  }

  updateDomainSkill(evaluationDomainSkills: EvaluationDomain) {
    let globalSkills = this.evaluationDomainTemplates.evaluationDomains.filter(a => a.evaluationDomainID == evaluationDomainSkills.evaluationDomainID)[0];

    let skillsSum = 0;
    globalSkills.evaluationDomainSkills.forEach(element => {
      if(element.average!=null){
        let skill = (element.average / 100) * element.scaleTo;
        element.weightValue = (element.scaleTo * (element.average / 10)); //should use countRanks
        element.evaluatorAssessmentValue=element.average;
        element.evaluatorAssessmentOptionsCount=10;//should use countRanks

        skillsSum += skill;
      }

    });
    let skillDomain = skillsSum;

    globalSkills.skillsResult = skillsSum  ;
    globalSkills.skillsResult = skillsSum*10;
  }

  calculateTotalEvaluation() {

    if (this.evaluationDomainTemplates == null) {
      return;
    }

    let domainsSum = 0;
    this.evaluationDomainTemplates.evaluationDomains.forEach(item => {
      if(item.skillsResult!=null){
        domainsSum += item.skillsResult;
      }

    })
    this.evaluationDomainTemplates.average = (domainsSum / this.evaluationDomainTemplates.scaleTo) * 10;

    let evaluationResultRanksModel=this.getEvaluationResultRanksModel(this.evaluationDomainTemplates.average*10);
    let rosourceName=evaluationResultRanksModel.resourceName;
    this.evaluationDomainTemplates.resourceName=rosourceName;

    //Fill the add Evaluaion model
    this.addEvaluationData.evaluationResultRankID=evaluationResultRanksModel.evaluationResultRankID;
    this.addEvaluationData.evaluationResultRanksMasterID=evaluationResultRanksModel.evaluationResultRanksMasterID;
    this.addEvaluationData.average=this.evaluationDomainTemplates.average;
    this.addEvaluationData.evaluationDomainTemplateID=this.evaluationDomainTemplates.evaluationDomainTemplateID;
    this.addEvaluationData.sumOfFormativeWeights=this.evaluationDomainTemplates.scaleTo;
    this.addEvaluationData.summativeAssessmentWeightValue=domainsSum;


    this.addEvaluationData.evaluationDomainTemplates=this.evaluationDomainTemplates;

    this.changeEvaluationData(this.addEvaluationData);
  }

  getEvaluationResultRanksModel(value):EvaluationResultRanksModel{
    let model;
    this.addEvaluationData.evaluationDomainTemplates.evaluationResultRanksModel.forEach(item=>{
      if(value>=item.from&&value<=item.to){
        model=item;
        //rosourceName= item.resourceName;
      }
    })
    return model;
  }

  changeEvaluationData(model){
    this.addEvaluationDataObservable.next(model);
  }
  fillAddEvaluationModel(){
    this.addEvaluationData.evaluatorComment=this.evaluatorComment;
    this.addEvaluationData.evaluatorRefID=this.customer.customerID;
    this.addEvaluationData.evaluationDomainTemplateScopeID=EvaluationDomainTemplateScopeEnum.CustomerToRental;
    this.addEvaluationData.evalueeID=null;//Per Khalid Information
    this.addEvaluationData.CreatedBy=this.customer.defaultName;
    this.addEvaluationData.evaluationLogsDetails=this.getEvaluationLogsDetails();
    this.addEvaluationData.vehicleID=this.vehicle.vehicleID;
  }
  getEvaluationLogsDetails(){
    let evaluationLogDetails=[];
    this.evaluationDomainTemplates.evaluationDomains.forEach(domain=>{
      domain.evaluationDomainSkills.forEach(a =>{
        a.evaluationResultRankID=this.addEvaluationData.evaluationResultRankID;
        //a.average=null;
      })
      evaluationLogDetails.push.apply(evaluationLogDetails, domain.evaluationDomainSkills)
    })
    return evaluationLogDetails;
  }
  addEvaluation(){

    if(this.evaluatorComment == undefined){
      this.errorReviewMsg = true;
    } else{
      this.errorReviewMsg = false;
      this.fillAddEvaluationModel();
      this.bookingService.addPublicReview(this.addEvaluationData).subscribe(res =>{
        this.bookingService.updateViewBookingState();
        this.close(true);
     })
    }

    
  }

}
